import { InjectionToken } from "@angular/core";

export const ALLOW_AUTOCOMPLETE = new InjectionToken<boolean>("ALLOW_AUTOCOMPLETE");
